// extracted by mini-css-extract-plugin
export default {"body":"Body_body__inTNX","content":"Body_content__bag9H","headerText":"Body_headerText__8fR9e"};